import React, { useMemo } from 'react';
import { Box, Unstable_Grid2 as Grid } from '@mui/material';

import { FormInputProps, Typography } from '@occc-app/design-system';

import { useField } from 'react-final-form';
import { SegmentSelectField } from './SegmentSelectField';
import { AudienceFormValues } from '../../types';

const selectFieldInputProps: FormInputProps = {
  margin: 'none',
};

type AudienceSegmentsFormContentProps = {
  name: string;
};

export const SegmentsFormContent = React.memo(({ name }: AudienceSegmentsFormContentProps) => {
  const {
    input: { value: values },
  } = useField<AudienceFormValues['segments']>('segments', {
    subscription: { value: true },
  });

  const excludes = useMemo(() => {
    const inAllSegments = values?.inAllSegments?.map((value) => value.uuid) || [];
    const inAnySegments = values?.inAnySegments?.map((value) => value.uuid) || [];
    const notInAnySegments = values?.notInAnySegments?.map((value) => value.uuid) || [];

    return {
      inAllSegments: [...inAllSegments, ...notInAnySegments],
      inAnySegments,
      notInAnySegments: [...notInAnySegments, ...inAllSegments],
    };
  }, [values?.inAllSegments, values?.inAnySegments, values?.notInAnySegments]);

  return (
    <Box mb={2}>
      <Typography paragraph variant='subtitle1'>
        Members are in
      </Typography>
      <Grid container spacing={3}>
        <Grid sm={12} md={6}>
          <SegmentSelectField
            name={`${name}.inAllSegments`}
            label='In all segments'
            inputProps={selectFieldInputProps}
            idExcludes={excludes.inAllSegments}
          />
        </Grid>
        <Grid sm={12} md={6}>
          <SegmentSelectField
            name={`${name}.inAnySegments`}
            label='In any segments'
            inputProps={selectFieldInputProps}
            idExcludes={excludes.inAnySegments}
          />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Typography paragraph variant='subtitle1'>
          Members are NOT in
        </Typography>
        <Grid container spacing={3}>
          <Grid sm={12} md={6}>
            <SegmentSelectField
              name={`${name}.notInAnySegments`}
              label='In any segments'
              inputProps={selectFieldInputProps}
              idExcludes={excludes.notInAnySegments}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
});
